export const translation_fr = (location: string) => {
    return (
        {
            messages: {
                "language": `${location} Francais`,
                
                
                // # Logic
                "cityID": "2",
                "modal-class": "none",
                "ogLocale": "fr_ca",
                "page.lang": "fr-CA",
                
                // # Header
                // #-----SEO
                "altTag.logoImage": "Andmar Eco-Energy Logo Long",
                "altTag.roundLogo": "Andmar Eco-Energy Logo Rond",
                "altTag.CtaButton": "Planifier Rendez-vous Bouton",
                "altTag.menuCtaButtonRound": "Planifier Rendez-vous Bouton Rond",
                // #------
                "nav.homepage": "Accueil",
                "nav.solutions": "Solutions",
                "nav.resources": "Ressources",
                "nav.portfolio": "Portfolio",
                "nav.contact-us": "Contact",
                "nav.governmentsIncentives": "Incitatifs Gouvernementaux",
                "nav.referrals": "Programme de Référence",
                "nav.faq": "FAQ",
                "nav.careers": "Emplois",
                "nav.financing": "Financement",
                "nav.ctabutton": "navCtaButtonFr",
                
                // # Footer
                "cta-text.title": "Commencez à économiser aujourd'hui!",
                "cta-text.text": `Réservez une estimation GRATUITE et demandez à l'un de nos Représentants de ${location} de vous guider à travers les détails du programme.`,
                "footer-cta-button": "Réservez maintenant!",
                
                "contact-info.title": "INFORMATIONS DE CONTACT",
                "contact-info.telephone-tag": "Téléphone: ",
                "contact-info.tollfree-tag": "Sans Frais: ",
                "contact-info.tollfree-number": "1-800-310-6108",
                "contact-info.email-tag": "Courriel:  ",
                
                "hours.title": "HEURES D'OUVERTURE",
                "hours.week-tag": "Lundi à Vendredi : ",
                "hours.week-hours": "8h00-18h00",
                "hours.saturday-tag": "Samedi : ",
                "hours.saturday-hours": "8h00-12h00",
                "hours.sunday-tag": "Dimanche : ",
                "hours.sunday-hours": "Fermé",
                "footer-text": "Le spécialiste de thermopompes résidentielles! Nous fournissons des solutions vertes et un confort inégalé aux propriétaires d’habitation.",
                "footer-copyright": `© ${new Date().getFullYear()}  Andmar Eco-Energy ${location}`,
                
                
                // # Home Page
                // #-----Page SEO
                "homepage.title": `Andmar Eco-Energy ${location} - Page d'Acceuil`,
                "homepage.meta-description": `Andmar Eco-Energy ${location} fournit des solutions vertes et un confort inégalé aux propriétaires d’habitation.`,
                "homepage.meta-keywords": `Andmar ${location} Thermopompe Mural Mini-Split Electrique Système Central`,
                "homepage.meta-robots": "index, follow, notranslate",
                "homepage.canonical": "https://www.andmar.ca/edmundston/fr/",
                "homepage.alternateHrefLangEn": "https://www.andmar.ca/edmundston/en/",
                "homepage.alternateHrefLangFr": "https://www.andmar.ca/edmundston/fr/",
                
                "altTag.GirlHeatPumpImage": `Andmar Eco-Energy ${location} Photo locale de Page d'Acceuil`,
                "altTag.HeatPumpIconLImage": "Icône de Thermopompe",
                "altTag.HeatPumpIconSImage": "Icône de Thermopompe",
                "altTag.GrillIconLImage": "Icône de grille de Thermopompe Central",
                "altTag.GrillIconSImage": "Icône de grille de Thermopompe Central",
                "altTag.FanIconLImage": "Icône de Ventilateur de Thermopompe",
                "altTag.FanIconSImage": "Icône de Ventilateur de Thermopompe",
                "altTag.SnowFlakeIconLImage": "Icône de refroidissement par Thermopompe",
                "altTag.SnowFlakeIconSImage": "Icône de refroidissement par Thermopompe",
                "altTag.CompanyEmployeeImage": `Photo d'Employés d'Andmar Eco-Energy ${location}`,
                // #-----Page SEO/
                
                "PresentationImage":"EdmundstonPresentation",
                "home.maintext1": "SPÉCIALISTE DES THERMOPOMPES RÉSIDENTIELLES",
                "home.maintext2": "Andmar Eco-Energy fournit des solutions vertes et un confort inégalé aux propriétaires d’habitation.",
                
                "attribute1.title": "COMPÉTENCE",
                "attribute1.text": "Spécialisation au domaine résidentiel",
                "attribute2.title": "QUALITÉ",
                "attribute2.text": "Utilise les meilleurs matériaux, main-d'œuvres et professionnels qualifiés pour votre maison",
                "attribute3.title": "SATISFACTION",
                "attribute3.text": "Fournit la flexibilité et l'effort de collaboration pour assurer l'achèvement du projet",
                "attribute4.title": "DÉVOUEMENT",
                "attribute4.text": "Crée un vif intérêt pour l'énergie verte, la prospérité et le confort dans chaque habitation",
                
                "why-andmar.title": "Andmar Eco-Energy",
                "why-andmar.text1": "Andmar Eco-Energy est le spécialiste de thermopompes résidentielles. Nous fournissons des solutions vertes et un confort inégalé aux propriétaires d’habitation.",
                "why-andmar.text2": "Notre Équipe est basée sur la conviction que les besoins de nos clients sont de la plus haute importance. Nos Techniciens Certifiés se présentent propres et soignés, traitent votre maison comme si c’était la nôtre et prennent affinité aux détails. Nous offrons la flexibilité et l’effort de collaboration pour assurer une entière satisfaction.",
                "why-andmar.text3": "Nous apprécions la possibilité de gagner votre confiance et de fournir le meilleur service dans l’industrie.",
                "why-andmar.signature": "Équipe de gestion",
                
                "solutions": "Solutions",
                "solutions1.title": "Thermopompe Murale",
                "solutions1.text": "Les thermopompes murale réduisent le coût de chauffage, fournissent l'air climatisé et sont également un excellent complément pour les systèmes de chauffage existants.",
                "solutions2.title": "Thermopompe à Conduit",
                "solutions2.text": "Les thermopompe canalisées offre la flexibilité de chauffer ou de refroidir chaque pièce de votre maison.",
                "solutions3.title": "Entretien de Thermopompe",
                "solutions3.text": "L'entretien régulier de votre système de chauffage et de refroidissement est la clé de la longévité, de l'efficacité et de la qualité de l'air.",
                "solutions4.title": "Mise à niveau Électrique",
                "solutions4.text": "Le panneau électrique contrôle toute l'électricité de votre maison. Assurez-vous qu'il est conforme au code avec une mise à niveau du panneau électrique.",
                
                "why-our-team.title": "Pourquoi Notre Équipe",
                "why-our-team.text": "Notre équipe est basée sur la conviction que les besoins de nos clients sont de la plus haute importance.",
                
                "areas-we-serve": "Zones de Services",
                "activeArea": "Zone Active",
                "comingSoonArea": "Bientôt Disponible",
                
                "citySelectedMarker": `${location}`,
                
                // # Solutions - Page
                // #-----Page SEO
                // #-----
                "solutionsPage.title": `Solutions - Andmar Eco-Energy ${location}`,
                "solutions.maintext1": "Solutions",
                
                "solutions.maintext2": `Nos Solutions pour la région de ${location}`,
                "solutions.companyDescription": `Andmar Eco-Energy ${location} fournit des solutions vertes et un confort inégalé aux propriétaires d’habitation.`,
                
                "solutionsCard1.title": "Thermopompe Murale",
                "solutionsCard1.Description": "Les Thermopompes Murale offrent la climatisation, des économies de chauffage et la déshumidification dans de nombreuses applications de modernisation. Ils constituent également un excellent complément aux systèmes de chauffage par plinthes électriques ou à eau chaude existants.",
                
                "solutionsCard2.title": "Thermopompe à Conduit",
                "solutionsCard2.Description": "Les Thermopompes à Conduits offre la possibilité de chauffer ou de refroidir toutes les pièces de votre maison. Votre maison peut être zonée pour maximiser l'efficacité énergétique et vous pouvez la personnaliser en fonction de votre style de vie.",
                
                "solutionsCard3.title": "Maintenance de Thermopompes",
                "solutionsCard3.Description": "L'entretien régulier de votre système de chauffage et de climatisation est la clé de la longévité, de l'efficacité et de la qualité de l'air.",
                
                "solutionsCard4.title": "Modernisation Electrique",
                "solutionsCard4.Description": "Le panneau électrique contrôle toute l'électricité de votre maison. Assurez-vous qu'il est conforme au code et à jour avec une mise à niveau du panneau électrique.",
                
                "solutionsCard5.title": "Ventilateur à Récupération de Chaleur",
                "solutionsCard5.Description": "Le Ventilateur Récupérateur de Chaleur ventile votre maison tout en conservant l'énergie utilisée pour le chauffage et la climatisation. Il élimine l'excès d'humidité, les polluants atmosphériques, protège la structure de votre maison et la santé de votre famille.",
                
                
                
                // # Ductless Heat Pump - Page
                // #-----Page SEO
                "ductlessHeatPumpPage.title": `Andmar Eco-Energy ${location}- Solutions de Thermopompe Murale`,
                "altTag.LGPrestigeImage": "LG Prestige Thermopompe Murale Image",
                "altTag.LGGlossWhiteImage": "LG Gloss White Thermopompe Murale Image",
                "altTag.LGMirrorImage": "LG Mirror Thermopompe Murale Image",
                "altTag.LGCassetteImage": "LG Cassette Thermopompe Murale Image",
                "altTag.LGMultiFImage": "LG Multi F Thermopompe Murale Image",
                "altTag.MoneyBagSImage": "Icône de Sac d'Argent Abordable",
                "altTag.MoneyBagLImage": "Icône de Sac d'Argent Abordable",
                "altTag.ApprovalSignSImage": "Icône d'Approbation de Confort",
                "altTag.ApprovalSignLImage": "Icône d'Approbation de Confort",
                "altTag.EvolutionSImage": "Icône de flexibilité",
                "altTag.EvolutionLImage": "Icône de flexibilité",
                "altTag.BulbSImage": "Icône Écologique",
                "altTag.BulbLImage": "Icône Écologique",
                "altTag.LGLogoImage": "Logo LG",
                "altTag.LGWarrantyImage": "Image de Garantie LG",
                "altTag.MoneyBillImage": "Image de Paiement en Espèces",
                "altTag.MoneyBagImage": "Image de Paiement par Financement",
                
                
                // #-----/
                "ductless-heat-pump.title": `Thermopompe murale - Andmar Eco-Energy ${location}`,
                "ductless-heat-pump.maintext1": "Thermopompe Murale",
                
                "jump-menu.title1": "MODÈLES",
                "jump-menu.title2": "POURQUOI SANS CONDUIT",
                "jump-menu.title3": "POURQUOI LG",
                "jump-menu.title4": "OPTIONS DE PAIEMENT",
                
                "models": "Modèles",
                "model.title1": "LG PRESTIGE",
                "model.text1": "Thermopompe murale à haute efficacité énergétique.",
                "model.title2": "LG GLOSS WHITE",
                "model.text2": "La LG Gloss White fournit un chauffage et un refroidissement puissants et efficaces, dont la plupart sont certifiés Energy Star.",
                "model.title3": "LG MIRROR",
                "model.text3": "Faites l'expérience du vrai confort individuel. LG MIRROR est la solution parfaite à une variété de défis d'installation.",
                "model.title4": "LG CEILING CASSETTE",
                "model.text4": "Les climatiseurs à cassettes LG vous permettent de garder votre entreprise au frais, quelle que soit la température extérieure.",
                "model.title5": "LG MULTI F",
                "model.text5": "Les unités lG Multi F prennent en charge jusqu'à 4 unités intérieures pour une flexibilité de conception maximale.",
                
                "why-ductless.maintitle": "Avantages des Thermopompes Murales",
                "why-ductless.title1": "Abordable",
                "why-ductless.text1": "Réduire le coût de chauffage jusqu'à 50%",
                "why-ductless.title2": "Confort",
                "why-ductless.text2": "Fournit le chauffage, la climatisation, la déshumidification et la filtration de l'air",
                "why-ductless.title3": "Flexibilité",
                "why-ductless.text3": "Excellent complément pour les systèmes de chauffage existants",
                "why-ductless.title4": "Écologique",
                "why-ductless.text4": "Réduit les émissions mondiales de CO2​",
                
                "why-lg.maintitle": "Thermopompe Murale LG",
                "why-lg.title1": "LA THERMOPOMPE LA PLUS RECONNUE",
                "why-lg.text1": "LG est un leader mondial des termopompes murale et offre ce qu’aucune autre entreprise ne peut fournir; Le meilleur retour sur investissement, esthétiquement agréable, respectueux de l’environnement et fiables systèmes sans conduits.",
                "why-lg.title2": "EFFICACITÉ​",
                "why-lg.text2": "LG propose certaines des thermopompes sans conduits les plus écoénergétiques et certaines des plus silencieuse. Avec des fonctions intégrées telles que Jet Cool, Swing 4 voies et Power Heating, votre pompe à chaleur LG assurera à votre maison un environnement confortable tout au long de l’année.",
                
                "why-andmar.maintitle": "Andmar Eco-Energy",
                "why-andmar.text": "Nous fournissons des solutions écologiques et un confort exceptionnel aux propriétaires. Nous offrons une flexibilité et un effort de collaboration pour assurer une entière satisfaction.",
                
                
                "payment-options.title": "OPTIONS DE PAIEMENT",
                "payment-options.text": "Découvrir nos options de paiement",
                
                "payment-option1.title": "EN ESPÈCES",
                "payment-option1.attributetag1": "Méthodes de paiement",
                "payment-option1.attributetext1": "E-Tranfère, Chèque, Carte de crédit",
                "payment-option1.attributetag2": "Paiement",
                "payment-option1.attributetext2": "Paiement initial uniquement",
                "payment-option1.attributetag3": "Termes",
                "payment-option1.attributetext3": "NA",
                "payment-option1.attributetag4": "Coût initial réduit",
                "payment-option1.attributetext4": "NA",
                "payment-option1.attributetag5": "Aucune pénalité de paiement anticipé",
                "payment-option1.attributetext5": "NA",
                "payment-option1.attributetag6": "Installation qualifiée et expérimentée",
                "payment-option1.attributetext6": "",
                "payment-option1.cta-button": "Réservez Estimation Gratuite",
                
                "payment-option2.title": "FINANCEMENT*",
                "payment-option2.attributetag1": "Méthodes de paiement",
                "payment-option2.attributetext1": "Prélèvement automatique",
                "payment-option2.attributetag2": "Paiement",
                "payment-option2.attributetext2": "Aussi peu que 12$/semaine",
                "payment-option2.attributetag3": "Termes",
                "payment-option2.attributetext3": "Jusqu'à 10 ans",
                "payment-option2.attributetag4": "Coût initial réduit",
                "payment-option2.attributetext4": "",
                "payment-option2.attributetag5": "Aucune pénalité de paiement anticipé",
                "payment-option2.attributetext5": "",
                "payment-option2.attributetag6": "Installation qualifiée et expérimentée",
                "payment-option2.attributetext6": "",
                "payment-option2.attributetag7": "*Sujet à l'approbation de crédit",
                
                "payment-option2.cta-button": "Réservez Estimation Gratuite",
                
                
                // # Portfolio - Page
                "portfolio.title": `Portfolio - Andmar Eco-Energy ${location}`,
                "portfolio.maintext1": "Projets en Vedette",
                
                // # Referral - Page
                "referral.title": `Programme de Référence - Andmar Eco-Energy ${location}`,
                "referral.maintext1": "Programme de Référence",
                  
                "referral.subTitle1":"Recevez",
                "referral.subTitle2":"et faites économiser",
                "referral.subTitle3":" ",
                "referral.subTitle4":" ",
                "referral.subTitle5":"à vos AMIS sur leur",
                "referral.subTitle6":" ACHAT",

                "referral.text2":"Chez Andmar Eco-Energy, nous apprécions la confiance que vous accordez à notre entreprise et considérons que c'est un grand compliment lorsque nos clients réfèrent nos services à leurs familles et amis. Nous sommes toujours ravis de recevoir des recommandations qui nous permettent d'intégrer vos amis et votre famille à notre communauté de clients satisfaits. Nous savons que la meilleure façon de trouver un bon entrepreneur est de demander autour de vous et de trouver quelqu'un qui a fourni un excellent travail à un ami ou à un membre de la famille. Nous sommes honorés par le nombre de clients qui nous réfèrent à leurs amis, et nous sommes également reconnaissants pour votre recommandation. Merci pour votre confiance!",
                "referral.text3":"Nous vous remercions de votre partenariat et, pour vous remercier, nous vous proposons l'incitatif de référence comme suit:",
                "referral.termsTitle":"Termes et conditions",
                "referral.termsCondition1":"Une carte de référence par acheteur.",
                "referral.termsCondition2":"Aucune limite au nombre d'amis que vous pouvez référer.",
                "referral.termsCondition3":"Les référents reçoivent une carte-cadeau de 50 $ et l'acheteur reçoit un rabais de 50 $ sur sa première facture d'achat.",
                "referral.termsCondition4":"S'applique uniquement pour l'achat d'une thermopompe d'Andmar Eco-Energy.",
                "referral.termsCondition5":"Acceptable uniquement par un représentant Andmar Eco-Energy, le jour du devis.",
                "referral.termsCondition6":"Les référents doivent être enregistrés auprès d'Andmar Eco-Energy.",
                "referral.termsCondition7":"Le référé doit être un nouveau client d'Andmar Eco-Energy.",
                "referral.termsCondition8":"Une référence par personne.",
                "referral.incitativeText":"Vous avez quelqu'un en tête qui pourrait avoir besoin d'aide pour le chauffage et la climatisation ? Faites-le nous savoir et faites plaisir à vos amis.",

                
                // # Government-Grant-Incentive - Page
                "grant.title": `Subventions Gouvernementales Incitatifs - Andmar Eco-Energy ${location}`,
                "grant.maintext1": "Incitatifs Gouvernementaux",
                
                "grant.name2": "Programme Éconergétique pour les Maisons.",
                "grant.p1.1": "Les propriétaires au Nouveau-Brunswick ont l'opportunité d'améliorer l'efficacité énergétique de leur maison et de réduire leurs factures d'énergie grâce au ",
                //"grant.name1": "Subvention Canadienne pour des Maisons plus Vertes",
                //"grant.p1.2": " et le programme provincial ",
                
                "grant.p2.1": "Pour profiter de ce programme, les propriétaires doivent s'inscrire au ",
                "grant.link1": "https://www.saveenergynb.ca/fr/pour-votre-maison/programme-econergetique-pour-les-maisons/",
                "grant.p2.2": " ou en appelant le 1-800-663-6272.",
                //"grant.p3.1": "La Subvention canadienne pour des maisons plus vertes est un programme distinct dans lequel vous pouvez également faire une demande à ",
                //"grant.link2": "https://www.rncan.gc.ca/efficacite-energetique/efficacite-energetique-maisons/subvention-canadienne-pour-des-maisons-plus-vertes/23445",
                //"grant.p3.2": " ou en appelant le 1-833 -674-8282.",
                "grant.p4": "Il est important de noter que le Programme Éconergétique pour les Maisons est une initiative du gouvernement provincial. En tant que tel, ils sont la seule autorité pouvant fournir des détails précis sur les montants des subventions et les critères d'éligibilité. Cela assure que les propriétaires reçoivent un soutien fiable et officiel tout au long du processus visant à rendre leurs maisons plus écoénergétiques.",
                "grant.p5": "Merci de choisir Andmar Eco-Energy.",
                "grant.p6": "Merci de choisir Andmar Eco-Energy.",

                "grant.y2025m1.p1": "Il existe trois programmes gouvernementaux offerts aux propriétaires du Nouveau-Brunswick visant à améliorer l’efficacité énergétique et à réduire les coûts de chauffage:",
                "grant.y2025m1.at": "à ",
                "enhancedEnergySavingImage": "enhancedEnergySavingFR",
                "altTag.enhancedEnergySaving": "Image du programme d'économie d'énergie amélioré",
                "grant.y2025m1.p2": "Ce programme aide les propriétaires dont le revenu annuel combiné du ménage est de 70 000 $ ou moins. Les participants admissibles peuvent bénéficier d’améliorations énergétiques sans frais, notamment l’isolation des sous-sols, des greniers et des murs, l’amélioration de la ventilation pour résoudre les problèmes de qualité de l’air ou d’humidité, ainsi que la mise à niveau des systèmes de chauffage. Ces améliorations visent à réduire la consommation d’énergie et à améliorer le confort du domicile.",
                "grant.y2025m1.p3": "Pour profiter de ce programme, les propriétaires doivent s'inscrire au ",
                "grant.y2025m1.p3.1": "Programme Éconergétique Amélioré ",
                "grant.y2025m1.link.p3": "https://www.saveenergynb.ca/fr/pour-votre-maison/programme-econergetique-ameliore/ ",
                "grant.y2025m1.p3.2": "ou en appelant le 1-800-663-6272.",

                "totalHomeEnergySavingImage": "totalHomeEnergySavingFR",
                "altTag.totalHomeEnergySaving": "Image du programme éconergétique pour les maisons",
                "grant.y2025m1.p4": "Cette initiative aide les propriétaires à passer du chauffage au mazout aux thermopompes électriques. Au Nouveau-Brunswick, le Programme fédéral de Conversion Abordable du Mazout à la Thermopompe est combiné avec le Programme Éconergétique pour les Maisons. Les participants admissibles peuvent recevoir jusqu’à 15 000 $ pour l’achat et l’installation de thermopompes conçues pour les climats froids. Ce financement couvre également les mises à niveau électriques et mécaniques nécessaires, le retrait sécuritaire des réservoirs de mazout, ainsi que l’installation de systèmes de chauffage électrique de secours si nécessaire.",
                "grant.y2025m1.p5": "Pour profiter de ce programme, les propriétaires doivent s'inscrire au ",
                "grant.y2025m1.p5.1": "Programme Éconergétique pour les Maisons ",
                "grant.y2025m1.link.p5": "https://www.saveenergynb.ca/fr/pour-votre-maison/programme-econergetique-pour-les-maisons/ ",
                "grant.y2025m1.p5.2": "ou en appelant le  1-800-663-6272.",
                
                "greenerHomeLoanImage": "greenerHomeLoanFR",
                "altTag.greenerHomeLoan": "Greener Home Loan Image",
                "grant.y2025m1.p6": "Un programme fédéral offrant des prêts sans intérêt pouvant atteindre 40 000 $ pour aider les propriétaires canadiens à entreprendre d’importantes rénovations visant à améliorer l’efficacité énergétique de leur domicile. Pour être admissibles, les propriétaires doivent être éligibles et faire une demande pour la Subvention canadienne pour des maisons plus vertes ou un programme provincial équivalent, effectuer une évaluation énergétique avant les rénovations et choisir au moins une amélioration admissible recommandée par un conseiller en efficacité énergétique.",
                "grant.y2025m1.p7": "Pour profiter de ce programme, les propriétaires doivent s'inscrire au ",
                "grant.y2025m1.p7.1": "Programme d'Initiative Canadienne pour des Maisons plus Vertes ",
                "grant.y2025m1.link.p7": "https://ressources-naturelles.canada.ca/efficacite-energetique/efficacite-energitique-maison/initiative-canadienne-maisons-plus-vertes/pret-canadien-maisons-plus-vertes ",
                "grant.y2025m1.p7.2": "ou en appelant le 1-833-674-8282.",
                
                
                // # Contact Us - Page
                "contact-us.title": `Contactez-nous - Andmar Eco-Energy ${location}`,
                "contact-us.maintext1": "Contactez-nous",
                
                "card1.title": "Informations de Contact",
                
                "card1.attributetext3": "Envoyez-nous un email",
                "card1.attributetext4": "edmundston@andmar.ca",
                "card1.attributetext5": "Appelez-nous",
                "card1.attributetext6": "1-506-501-2241",
                
                "card2.title": "Écrivez-Nous",
                "card2.attributetext1": "Nom",
                "card2.attributetext2": "Courriel",
                "card2.attributetext3": "Message",
                "card2.attributetext4": "Téléphone",
                "card2.send-button": "ENVOYER",
                "card2.send-success": "Merci de nous avoir envoyé un courriel! Votre message a été soumis.",
                
                "hours.tilte": "Heures d'ouverture",
                "hours.attributetag1": "LUNDI",
                "hours.attributetext1": "8h00-18h00",
                "hours.attributetag2": "MARDI",
                "hours.attributetext2": "8h00-18h00",
                "hours.attributetag3": "MERCREDI",
                "hours.attributetext3": "8h00-18h00",
                "hours.attributetag4": "JEUDI",
                "hours.attributetext4": "8h00-18h00",
                "hours.attributetag5": "VENDREDI",
                "hours.attributetext5": "8h00-16h00",
                "hours.attributetag6": "SAMEDI",
                "hours.attributetext6": "8h00-12h00",
                "hours.attributetag7": "DIMANCHE",
                "hours.attributetext7": "Fermé",
                
                // # 404 - Page
                "page404.title": "404 - Page Non Trouvé - Andmar Eco-Energy Moncton",
                "page404.maintext1": "PAS TROUVÉ",
                "page404.maintext2": "Vous venez d'ouvrir une page qui n'existe pas ... la tristesse.",
                
                // # Covid19-priority-booking - Page
                "registerForm.title": "Enregistré vous ici",
                "card2.attributetextphone": "Téléphone",
                "covid19.maintext1": "Votre santé et celle nos employés sont importantes pour nous, en raison de la situation actuelle du Covid-19, nous retenons toutes nos opérations non essentielles. En attendant, n'hésitez pas à vous inscrire à notre liste de réservation, afin que nous puissions planifier votre rendez-vous dans les plus brefs délais. Veuillez noter que les réservations se feront sur une base du premier arrivé, premier servi.",



            },
            slugs:{
                '/contact-us': '/contactez-nous',
                "/solutions": "/solutions",
                "/solutions/ductless-heat-pump": "/solutions/thermopompe-murale",
                "/governments-incentives-2025": "/incitatifs-gouvernementaux-2025",
                "/referral": "/programme-référence",
            }

        }
    )
}
